const _cookieVarPrefix = 'SBEADMIN_';
export const CookieVars = {
  ACCESS_TOKEN: _cookieVarPrefix + 'ACCESS_TOKEN',
  REFRESH_TOKEN: _cookieVarPrefix + 'REFRESH_TOKEN',
  USER_DATA: _cookieVarPrefix + 'USER_DATA',
};
